import { motion } from "framer-motion";

/**
 * Animated, theme-aware Spaces (workspaces) mockup: a workspace switcher with
 * separate contexts. Replaces spaces screenshots.
 */

const SPACES = [
  { icon: "bi-briefcase-fill", name: "Work", count: "128 bookmarks", active: true },
  { icon: "bi-person-fill", name: "Personal", count: "64 bookmarks" },
  { icon: "bi-mortarboard-fill", name: "Research", count: "212 bookmarks" },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1, delayChildren: 0.2 } },
};
const row = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export const SpacesMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--spaces ${className}`}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-grid-1x2-fill me-1" />
          Switch space
        </div>
      </div>

      <div className="obm-mock__body">
        <motion.div
          className="obm-mock__spaces"
          variants={container}
          initial={false}
          animate="show"
        >
          {SPACES.map((s) => (
            <motion.div
              key={s.name}
              className={`obm-mock__space ${s.active ? "is-active" : ""}`}
              variants={row}
            >
              <span className="obm-mock__space-icon">
                <i className={`bi ${s.icon}`} />
              </span>
              <div className="obm-mock__meta">
                <span className="obm-mock__title">{s.name}</span>
                <span className="obm-mock__domain">{s.count}</span>
              </div>
              {s.active && <i className="bi bi-check-lg obm-mock__space-check" />}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default SpacesMock;
